import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/occupation-categories/OccupationCategoriesAction";
import {
  DeleteButton,
  ExportButton,
  FormButton,
  copy,
  deletionAlert,
  exportToExcel,
  exportToPDF,
  getAuthorities,
  noRecordsAlert,
  print,
  redirectToPages,
  resultAlert
} from "../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { OccupationCategoriesFilter } from "./occupation-categories-filter/OccupationCategoriesFilter";
import { OccupationCategoriesTable } from "./occupation-categories-table/OccupationCategoriesTable";
import { useOccupationCategoriesUIContext } from "./OccupationCategoriesUIContext";

export function OccupationCategoriesCard() {
  // OccupationCategories UI Context
  const categoriesUIContext = useOccupationCategoriesUIContext();
  const categoriesUIProps = useMemo(() => {
    return {
      ids: categoriesUIContext.ids,
      setIds: categoriesUIContext.setIds,
      queryParams: categoriesUIContext.queryParams,
      setQueryParams: categoriesUIContext.setQueryParams,
      openNewCategoryPage: categoriesUIContext.openNewCategoryPage
    };
  }, [categoriesUIContext]);
    
  // Getting curret state of Occupation Category list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.occupationCategories }),
    shallowEqual
  );
  const { actionsLoading, isSuccess, type, authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized, isAdditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);

  // Occupation Categories Redux state
  const dispatch = useDispatch();  

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  /** Belli Bir Meslek Kategorisi Listesini Excele Aktarır */
  const exportCategoriesToExcel = () => {
    dispatch(actions.getAllCategories(categoriesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const widths = [30];
      const columns = ["Adı"];
      entities.forEach(entity => rows.push([entity.category]));
      const filename = "Meslek Kategorisi Listesi"
      exportToExcel({ columns, rows, widths, filename });
    });
  }

  /** Belli Bir Meslek Kategorisi Listesini PDF e Aktarır */
  const exportCategoriesToPDF = () => {
    dispatch(actions.getAllCategories(categoriesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const views = [ 
        {
          header: "Adı",
          rows: entities.map(entity => entity.category)
        }
      ];
  
      const filename = "Meslek Kategorisi Listesi";
      exportToPDF(views, filename);
    });
  }

  /** Belli Bir Meslek Kategorisi Listesini Yazdırma Penceresini Açar */
  const printCategories = () => {
    dispatch(actions.getAllCategories(categoriesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const data = [];    
      const header = "Meslek Kategorisi Listesi";
      const properties = ["Adı"];

      entities.forEach(entity => {
        data.push({
          "Adı": entity.category
        });
      });

      print({ data, properties, header });
    });
  }

  /** Belli Bir Meslek Kategorisi Listesini Panoya Kopyalar */
  const copyCategories = () => {
    dispatch(actions.getAllCategories(categoriesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const header = "Meslek Kategorisi Listesi";
      const columns = ["Adı"];
      entities.forEach(entity => rows.push([entity.category]));
      copy({ header, columns, rows });
    });
  }

  /** Belli Bir Meslek Kategorisi Listesini Siler */
  const deleteCategories = (ids) => {
    if (typeof ids === 'string') ids = ids.split(",");
  
    if (ids.length < 1) {
      noRecordsAlert();     
      return;
    }
  
    deletionAlert().then(result => {
      if (result.isConfirmed) dispatch(actions.deleteCategories(ids)).then(result => onResult(result));
    });
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
  
    if (isSuccess) {
      setTimeout(() => {
        // clear selections list
        categoriesUIProps.setIds([]);
        // refresh list after deletion
        dispatch(actions.getCategories(categoriesUIProps.queryParams));        
      }, 2500);
    }
  };
  
  const title = <>Meslek Kategorisi Listesi{categoriesUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{categoriesUIProps.ids.length}</span>]</> :
                  ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        {
          (isExportationAuthorized || isAdditionAuthorized || isDeletionAuthorized) &&
          <CardHeaderToolbar>
            {
              isExportationAuthorized &&
              <ExportButton
                exportToExcel={exportCategoriesToExcel}
                exportToPDF={exportCategoriesToPDF}
                print={printCategories}
                copy={copyCategories}
              />
            }
            {
              isAdditionAuthorized &&
              <FormButton
                path="Navigation/Plus"
                title="Yeni Kategori"
                method={categoriesUIProps.openNewCategoryPage}
              />
            }              
            {
              isDeletionAuthorized &&
              <DeleteButton
                title="Seçilenleri Sil"
                method={() => deleteCategories(categoriesUIProps.ids)}
              />
            }
          </CardHeaderToolbar>
        }        
      </CardHeader>
      <CardBody>
        <OccupationCategoriesFilter />
        <OccupationCategoriesTable
          deleteCategories={deleteCategories}
        />
      </CardBody>
    </Card>
  );
}